"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = require("ayvri-ui/lib/button");
var React = require("react");
var typestyle_1 = require("typestyle");
var _1 = require("./");
var styles_1 = require("./styles");
exports.SceneList = function (props) {
    var cards = props.cards, moreCards = props.moreCards, className = props.className, renderFooter = props.renderFooter, onFetchMore = props.onFetchMore;
    return (React.createElement("div", { className: typestyle_1.classes(styles_1.styles.list, className) },
        cards.map(function (card) { return renderCard(card); }),
        React.createElement(MoreButton, null)));
    function renderCard(card) {
        return (React.createElement("div", { key: "scene:" + card.scene.sceneId, className: styles_1.styles.card },
            React.createElement(_1.SceneCard, __assign({}, card)),
            renderFooter ? renderFooter(card.scene) : null));
    }
    function MoreButton() {
        if (!moreCards) {
            return null;
        }
        return (React.createElement("div", { className: styles_1.styles.moreResults },
            React.createElement(button_1.Button, { type: 'primary', size: 'small', onClick: onFetchMore }, "More")));
    }
};
exports.SceneList.displayName = 'SceneList';
